import React, { Component } from "react";
import { connect } from "react-redux";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { reduxForm } from "redux-form";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/image/new_logo.svg";
import avatar from "../../assets/image/avatar_placeholder.png";
import search from "../../assets/image/search.svg";
import product_grey from "../../assets/image/product_grey.svg";
import product_red from "../../assets/image/product_red.svg";
import { logout, personalInfo, getHeaderDropData, getHeaderDropShop, setVisiblePrice } from "../../actions/authActions";
import Search from "./Search";
import nonAvatart from "../../assets/image/non-avatar.png";
import Frame_big from "../../assets/image/Frame_big.svg";
import { ReactComponent as BarcodeIcon } from "../../assets/image/barcode-scan.svg";
import DefaultButton from "../HelperComponents/DefaultButton/DefaultButton";
import DialogComponent from "../HelperComponents/DialogComponent/DialogComponent";
import CircularProgress from "@material-ui/core/CircularProgress";
import burger_img from "../../assets/image/header-menu.svg";
import cart_img from "../../assets/image/header-cart.svg";
import moment from "moment";
import quitImg from "../../assets/image/quit.svg";
import statsImg from "../../assets/image/stats.svg";
import motivationImg from "../../assets/image/motivation.svg";
import Sidebar from "../CategorySidebar/CategorySidebar";
import { toFixedNoRounding } from "../../helpers/functions";
import CustomSpinner from "../HelperComponents/CustomSpinner/CustomSpinner";

import axios from "axios";

import {
    cartUpdate,
    GetClientInfo,
    sendToPicking,
    sessionEnd,
    setAddress, setDate,
    setNeedDelivery
} from "../../actions/clientAuthActions";

import "./Header.scss";
import MakeOrder from "./MakeOrder";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuIsOpen: false,
            loading: true,
            consultationStatus: localStorage.getItem("consultationStatus") || "finish",
            clientInfo: JSON.parse(localStorage.getItem("client_info")),
            cart: localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : [],
            clientUrl: "",
            clientModal: "close",
            buttonLoad: false,
            clientModalSuccess: false,
            sendClientError: "false",
            catalogOpen: false,
            loadingDrop: true,
            loadingShop: true,
            openCart: false,
        };
        this.cancelToken = undefined;
    }

    toggleDialog = () => {
        this.setState(({ openCart }) => ({
            openCart: !openCart
        }));
    };


    componentDidUpdate(prevProps, prevState) {
        if (this.props.loc === "/main/client") {
            this.redirect();
        }
        if (!this.props.loc.includes("/client")) {
            if (
                prevProps.loc.includes("/client/found") ||
                prevProps.loc.includes("/client/not-found") ||
                prevProps.loc.includes("/client/registration")
            ) {
                this.setState({ clientUrl: prevProps.loc });
            }
        }
        if (
            (this.props.productsError === 401 && prevProps.productsError !== 401) ||
            (this.props.categoryError === 401 && prevProps.categoryError !== 401)
        ) {
            localStorage.removeItem("token");
            localStorage.setItem("is_logged", "false");
            this.props.history.push("/auth/login");
        }
    }

    componentDidMount() {
        this.props.personalInfo().then(res => {
            this.setState({ loading: false });
            if (res.error) {
                localStorage.removeItem("token");
                this.props.history.push("/auth/login");
            }
        });
        if (this.props.loc === "/main/client") {
            this.redirect();
        }
    }

    redirect = () => {
        const { history } = this.props;
        const { clientUrl } = this.state;
        if (localStorage.getItem("regForm")) {
            history.push("/main/client/registration");
        } else if (!localStorage.getItem("client_phone") || localStorage.getItem("client_info") === null) {
            if (clientUrl === "") {
                history.push("/main/client/login");
            } else {
                history.push(`${clientUrl}`);
            }
        } else {
            history.push("/main/client/info");
        }
    };

    handleOpenMenu = () => {
        setTimeout(() => {
            this.setState({
                menuIsOpen: false
            });
        }, 100);
    };

    openMenu = () => {
        const { getHeaderDropShop } = this.props;
        this.setState(({ menuIsOpen }) => ({
            menuIsOpen: !menuIsOpen,
            loadingDrop: true
        }));
        getHeaderDropShop(localStorage.getItem("storage_id")).then(res => {
            if (res.payload && res.payload.status && res.payload.status === 200) {
                this.setState({ loadingDrop: false });
            } else if (res.error) {
            }
        });
    };

    handleOut = () => {
        const { history, logout } = this.props;
        logout().then(res => {
            localStorage.clear();
            history.push("/auth/login");
        });
    };

    toggleClientModal = status => {
        this.setState(({ clientModal, buttonLoad }) => ({
            clientModal: !!status ? status : !clientModal,
            buttonLoad: status === "close" ? false : buttonLoad,
            sendClientError: "false"
        }));
    };

    sendClient = () => {
        const { sendToPicking } = this.props;
        this.setState({ buttonLoad: true });
        sendToPicking(localStorage.getItem("storage_id")).then(res => {
            if (res.payload && res.payload.status && res.payload.status === 200) {
                this.setState({
                    buttonLoad: false,
                    clientModal: false,
                    clientModalSuccess: true
                });
            } else {
                this.setState({
                    buttonLoad: false,
                    sendClientError: res.error.response.data.detail
                });
            }
        });
    };

    render() {
        const {
            menuIsOpen,
            loading,
            clientModal,
            buttonLoad,
            clientModalSuccess,
            sendClientError,
            catalogOpen,
            loadingDrop,
            openCart
        } = this.state;

        const { accountInfo, data, visiblePrice, setVisiblePrice, history } = this.props;
        if (loading) return null;

        // --- ВИПРАВЛЕНИЙ БЛОК РОЗРАХУНКУ ---
        let cart = localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : [];

        // Рахуємо загальну суму так само, як у MakeOrder
        const calculatedTotal = cart.reduce((acc, el) => {
            const retail = Number(el.item.retail_price || 0);
            const wholesale = Number(el.item.wholesale_price || 0);

            let finalPrice = retail;

            // Перевіряємо тип ціни
            if (
                el.priceType === 'wholesale_price' ||
                el.priceType === 'wholesale' ||
                el.priceType === 'opt' ||
                el.priceType === 'Оптовая' ||
                el.priceType === 2
            ) {
                finalPrice = wholesale;
            }

            return acc + (finalPrice * el.amount);
        }, 0);

        // Форматуємо для відображення
        const totalWithDiscount = toFixedNoRounding(calculatedTotal, 2);
        // totalAll передається в MakeOrder, хоча MakeOrder тепер рахує сам, 
        // але для сумісності залишимо це значення правильним
        const totalAll = totalWithDiscount;
        // ------------------------------------

        return (
            <header className="header_wrapper">
                <div className="header_container">
                    <div className={`sidebar-wrapper${catalogOpen ? " open" : ""}`}>
                        <Sidebar
                            closeEvent={() => {
                                this.setState({ catalogOpen: false });
                            }}
                            catalogOpen={catalogOpen}
                        />
                    </div>
                    <div className="head_block">
                        <div
                            className="burger-img"
                            onClick={() => {
                                setTimeout(() => this.setState({ catalogOpen: true }), 100);
                            }}
                        >
                            <img src={burger_img} alt="burger" />
                        </div>
                        <div className="logo">
                            <Link className="good_hover" to={`/main/shop`}>
                                <img src={logo} alt="logo" />
                            </Link>
                        </div>

                        <Search />
                        <div className="panel_info">
                            <NavLink to="/main/camera">
                                <BarcodeIcon />
                            </NavLink>
                            <NavLink to="/main/product">
                                <img className="grey" src={product_grey} alt="product_grey" />
                                <img className="red" src={product_red} alt="product_red" />
                            </NavLink>
                        </div>
                        <div
                            className="header-cart"
                            onClick={this.props.loc !== "/main/client/info" ? this.toggleDialog : null}
                        >
                            <div className="header-cart-img">
                                <img src={cart_img} alt="cart_img" />
                                {<div>{cart && cart.reduce((x, y) => x + Number(y.amount), 0)}</div>}
                            </div>
                            <div className="header-cart-other">
                                <p className="total">Итого:</p>
                                <p className="price">{totalWithDiscount} грн.</p>
                            </div>
                        </div>
                    </div>
                    <div className="header_mobile_bottom">
                        <div className="logo mobile">
                            <Link className="good_hover" to={`/main/shop`}>
                                <img src={logo} alt="logo" />
                            </Link>
                        </div>
                        <div className="menu" onClick={this.openMenu}>
                            <div className="avatar">
                                <img src={accountInfo.photo || avatar} alt="avatar" />
                            </div>
                            <div className="menu_info">
                                <span>{`${accountInfo.first_name} ${accountInfo.last_name}`}</span>
                                <p>{accountInfo.role}</p>
                            </div>
                        </div>
                    </div>
                    {menuIsOpen ? (
                        <ClickAwayListener onClickAway={this.handleOpenMenu}>
                            <div className="controls_wrapper">
                                <div className="controls_wrapper-sales">
                                    <p className="sales">Мои продажи</p>
                                    <p className="prices">{moment(new Date()).format("DD.MM.YYYY")}</p>
                                </div>
                                <div className="controls_wrapper-days">
                                    {loadingDrop ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "100%"
                                            }}
                                        >
                                            <CustomSpinner styles={{ marginTop: "2px", marginBottom: "6px" }} />
                                            <p>Сбор информации</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div>
                                                <span className="digits">{data && data.saleAmountDay}</span>
                                                <span>грн.</span>
                                                <p>сегодня</p>
                                            </div>
                                            <div>
                                                <span className="digits">{data && data.saleAmountMonth}</span>
                                                <span>грн.</span>
                                                <p>за месяц</p>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="controls_wrapper-sales">
                                    <p className="sales">Продажи магазина</p>
                                </div>
                                <div className="controls_wrapper-days">
                                    {loadingDrop ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "100%"
                                            }}
                                        >
                                            <CustomSpinner styles={{ marginTop: "2px", marginBottom: "6px" }} />
                                            <p>Сбор информации</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div>
                                                <span className="digits">{data && data.saleAmountWhsDay}</span>
                                                <span>грн.</span>
                                                <p>сегодня</p>
                                            </div>
                                            <div>
                                                <span className="digits">{data && data.saleAmountWhsMonth}</span>
                                                <span>грн.</span>
                                                <p>за месяц</p>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <hr />
                                <div className="controls_wrapper-pricePicker">
                                    <p>Ціна</p>
                                    <div className="controls_wrapper-pricePicker-wrapper">
                                        <button
                                            className={visiblePrice === 'wholesale_price' ? 'active' : ''}
                                            onClick={() => setVisiblePrice('wholesale_price')}
                                        >
                                            Опт
                                        </button>
                                        <button
                                            className={visiblePrice === 'retail_price' ? 'active' : ''}
                                            onClick={() => setVisiblePrice('retail_price')}
                                        >
                                            Роздріб
                                        </button>
                                        <div className="activeIndicator" />
                                    </div>
                                </div>
                                <Link to="#">
                                    <img src={statsImg} alt="stats" />
                                    <p>Показатели</p>
                                </Link>
                                <Link to="#">
                                    <img src={motivationImg} alt="stats" />
                                    <p>Мотивация</p>
                                </Link>
                                <div onClick={this.handleOut} className="quit">
                                    <img src={quitImg} alt="quit" /> <p>Выйти</p>
                                </div>
                            </div>
                        </ClickAwayListener>
                    ) : null}
                    <DialogComponent open={clientModal === "open"} onClose={() => this.toggleClientModal("close")}>
                        <div className="dialog_client">
                            <div>
                                Отправить в зону <br />
                                комплектации?
                            </div>
                            <div className="button_container">
                                <DefaultButton variant="contained" onClick={this.sendClient} disabled={buttonLoad}>
                                    {buttonLoad && <CircularProgress color="secondary" />}
                                    Да
                                </DefaultButton>
                                <DefaultButton
                                    variant="contained"
                                    onClick={() => this.toggleClientModal("close")}
                                    classes={`disline`}
                                >
                                    Нет
                                </DefaultButton>
                                {sendClientError !== "false" && <span className={`error_block`}>{sendClientError}</span>}
                            </div>
                        </div>
                    </DialogComponent>
                    <DialogComponent open={clientModalSuccess} onClose={() => this.setState({ clientModalSuccess: false })}>
                        <div className="dialog_client">
                            <img src={Frame_big} alt="Frame_big" />
                            <div>
                                Клиент отправлен <br />в зону комплектации
                            </div>
                        </div>
                    </DialogComponent>
                    <MakeOrder cart={cart} history={history} totalAll={totalAll} openCart={openCart} toggleDialog={this.toggleDialog} />
                </div>
            </header>
        );
    }
}


const validate = values => {
    const errors = {};
    if (!values.email) {
        errors.email = "Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2, 5}$/i.test(values.email)) {
        errors.email = "Invalid email";
    }
    if (!values.password) {
        errors.password = "Required";
    } else if (values.password.length < 8) {
        errors.password = "Must be 8 characters or more";
    }
    return errors;
};

Header = reduxForm({
    form: "HeaderForm",
    validate
})(Header);

const mapStateToProps = ({ auth, client, search, category, products }) => {
    return {
        accountInfo: auth.account,
        categoryError: category.error,
        productsError: products.error,
        cartUpdate: client.cart_update,
        cart: client.cart,
        data: auth.shopData,
        visiblePrice: auth.visiblePrice,

        clientInfo: client.client_info,
        needDelivery: client.needDelivery,
        selectedDate: client.selectedDate,
        deliveryAddress: client.deliveryAddress
    };
};

const mapDispatchToProps = {
    logout,
    personalInfo,
    sendToPicking,
    getHeaderDropData,
    getHeaderDropShop,

    GetClientInfo,
    sessionEnd,
    cartUpdate,
    setNeedDelivery,
    setAddress,
    setDate,
    setVisiblePrice
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);